/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Open the on-screen keyboard immediately when the search popdown is
  // opened. Until <details> has the `open` attribute, the panel is
  // `display: none` (browser default) and `visibility: hidden`, so it can't
  // be focused - and the native 'toggle' event fires as a queued task, after
  // the tap's user-gesture window has already closed, so focusing there
  // doesn't trigger the keyboard either. Instead, handle the tap on
  // <summary> ourselves: open <details> and focus the input synchronously,
  // inside the tap, before the browser's own (too-late) toggle runs.
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('header-search-popdown > details > summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (details.open) return;

    var panel = details.querySelector('.search-popdown');
    if (!panel) return;

    event.preventDefault();
    panel.style.visibility = 'visible';
    var input = panel.querySelector('input[type="search"]');
    if (input) input.focus({preventScroll: true});
    details.open = true;
  }, true);

  // Restore the panel's hidden state once it's closed again.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || details.tagName !== 'DETAILS' || details.hasAttribute('open')) return;

    var wrapper = details.closest('header-search-popdown');
    if (!wrapper) return;

    var panel = wrapper.querySelector('.search-popdown');
    if (panel) panel.style.visibility = '';
  }, true);

  // Essential Countdown Timer app: feed its top bar's live height into
  // --ect-bar-height so custom-typography.css can dock the sticky header
  // right below it instead of the two overlapping. The app injects its
  // bar asynchronously and appends it wherever it finds room, so watch for
  // it rather than assuming it exists on load.
  (function () {
    var BAR_SELECTOR = '.essential_countdown_annoucement_bar_wrapper';

    function updateBarHeight(bar) {
      var height = bar.offsetParent !== null ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--ect-bar-height', height + 'px');
    }

    function watchBar(bar) {
      updateBarHeight(bar);
      if (window.ResizeObserver) {
        new ResizeObserver(function () { updateBarHeight(bar); }).observe(bar);
      } else {
        window.addEventListener('resize', function () { updateBarHeight(bar); });
      }
    }

    var existingBar = document.querySelector(BAR_SELECTOR);
    if (existingBar) {
      watchBar(existingBar);
    } else {
      var barObserver = new MutationObserver(function () {
        var bar = document.querySelector(BAR_SELECTOR);
        if (bar) {
          barObserver.disconnect();
          watchBar(bar);
        }
      });
      barObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // window.theme.scrollTo already compensates for the sticky header's own
  // height (reads [data-header-height]), but has no idea the Essential
  // Countdown Timer bar sits on top of that header too — it's a
  // third-party element injected by JS, not something the theme's
  // calculation accounts for. Every feature that scrolls to an element
  // (the sticky add-to-cart bar's "select size" scroll, filters,
  // newsletter, product tabs, ...) was landing short by the bar's height,
  // leaving content tucked behind it. Wrapping the function to also
  // subtract --ect-bar-height fixes all of those call sites at once.
  (function () {
    function wrapScrollTo() {
      if (typeof window.theme === 'undefined' || typeof window.theme.scrollTo !== 'function' || window.theme.scrollTo.__ectWrapped) {
        return false;
      }

      var original = window.theme.scrollTo;
      function wrapped(elementTop) {
        var barHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ect-bar-height')) || 0;
        original(elementTop - barHeight);
      }
      wrapped.__ectWrapped = true;
      window.theme.scrollTo = wrapped;
      return true;
    }

    if (!wrapScrollTo()) {
      var attempts = 0;
      var retry = setInterval(function () {
        attempts++;
        if (wrapScrollTo() || attempts > 40) clearInterval(retry);
      }, 50);
    }
  })();

  // Mobile: hide the sticky header (docked below the countdown bar) while
  // scrolling down, reveal it on scroll up. Only takes effect once the
  // header has actually pinned itself — near the top of the page there's
  // nothing to get out of the way of.
  //
  // This uses its own native 'scroll' listener (rAF-throttled) rather than
  // theme.js's `theme:scroll` event, to rule out any timing/throttling
  // assumption tied to that event as a cause of this not triggering
  // reliably. `lastY` is the scroll position at the last decision point;
  // delta is measured against it every frame and only acts once it passes
  // a threshold, so a frame or two of jitter can't flip the state on its
  // own. While the header isn't pinned yet, lastY is kept in sync with the
  // live scroll position every frame, so the instant it pins, delta starts
  // at ~0 instead of carrying over scroll distance from before it existed
  // — that's what stops it from being hidden on the same frame it first
  // appears.
  //
  // Mobile Safari's address bar collapses as you scroll down, and during
  // that ~300ms animation window scrollY can read a few px lower than the
  // frame before even though the finger is still moving down — the
  // browser is adjusting for the now-taller viewport, not registering an
  // actual reversal. That false reversal was enough to immediately
  // re-show the header mid-scroll: it would hide, then pop back a moment
  // later. window.innerHeight changes during exactly that animation (and
  // essentially never during a real scroll), so a frame where it changed
  // is treated as chrome animating, not user input: the reference point
  // is resynced and that frame isn't judged. SHOW_THRESHOLD being higher
  // than HIDE_THRESHOLD is a second line of defense for any jitter that
  // isn't caught by the height check, while a real scroll-up gesture
  // (which moves far more than a few px) still clears it easily.
  (function () {
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var HIDE_THRESHOLD = 10;
    var SHOW_THRESHOLD = 25;
    var lastY = window.scrollY;
    var lastHeight = window.innerHeight;
    var ticking = false;

    function update() {
      ticking = false;
      var currentY = window.scrollY;
      var currentHeight = window.innerHeight;
      var heightChanged = currentHeight !== lastHeight;
      lastHeight = currentHeight;

      var header = mobileQuery.matches ? document.querySelector('.js__header__stuck') : null;

      if (!header) {
        document.body.classList.remove('ect-header-hidden');
        lastY = currentY;
        return;
      }

      if (heightChanged) {
        lastY = currentY;
        return;
      }

      var delta = currentY - lastY;
      if (delta > HIDE_THRESHOLD) {
        document.body.classList.add('ect-header-hidden');
        lastY = currentY;
      } else if (delta < -SHOW_THRESHOLD) {
        document.body.classList.remove('ect-header-hidden');
        lastY = currentY;
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
